// import axios from 'axios';
// import { t } from 'i18next';
// import React, { useCallback, useEffect, useRef, useState } from 'react';
// import { useLocation, useParams } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import { DataNotFound } from '../../../components/DataNotFound';
// import LoadingAnimation from '../../../components/LoadingAnimation';
// import Giftselectioncards from '../../../components/cards/Giftselectioncards';
// import baseURL, { getAsync, postAsync } from '../../../components/helper/axiosHelper';
// import { getStorage } from '../../../libs/getStorage';
// import { PageHitCountApi } from '../../../shared/Helper';

// const AddGiftService = () => {
//   const [data, setData] = useState([]);
//   const [projectList, setProjectList] = useState([]);
//   const [refresh, setRefresh] = useState(false);
//   const [projectListData, setProjectListData] = useState([]);
//   const [isLoad, setIsLoad] = useState(false);
//   const [datanotfound, setDatanotfound] = useState(false);
//   const [dateGet, setDateGet] = useState(false);
//   const [tableData, setTableData] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const userId = getStorage('id');
//   const [loadingBtnId, setLoadingBtnId] = useState(null); // button id ke liye

//   const headers = ['sNo', 'Project Name', 'Delete Projects'];

//   const hasMounted = useRef(false);

//   const { id, type } = useParams();
//   const token = localStorage.getItem('token');
//   const { pathname } = useLocation();

//   let headersList = {
//     Accept: '*/*',
//     Authorization: `Bearer ${token}`,
//     id: id,
//   };
//   useEffect(() => {
//     if (!hasMounted.current) {
//       getProjectsList();
//       hasMounted.current = true;
//     }
//     onRender();
//   }, [refresh]);

//   useEffect(() => {
//     const adminID = localStorage.getItem('apid');
//     if (adminID) {
//       PageHitCountApi(pathname, adminID);
//     }
//   }, []);

//   // const onRender = async () => {
//   //   const response = await axios.get(GetGiftService, { headers: headersList });
//   //   setData(response.data.data);
//   //   if (response.data.data) {
//   //     const projectGuid = [];
//   //     response?.data.data.forEach((item) => {
//   //       // projectGuid.push(item?.projectID);

//   //       projectGuid.push({
//   //         projectID: item?.projectID,
//   //         projectTypeIdInt: item?.projectTypeIdInt,
//   //       });
//   //     });
//   //     handleProjectGUID(projectGuid);
//   //   }
//   // };
//   const onRender = async () => {
//     const response = await getAsync('GiftService/GetGiftProjectByGiftTypeId', headersList);
//     setData(response.data);
//     if (response.data) {
//       const projectGuid = [];
//       response?.data.forEach((item) => {
//         projectGuid.push({
//           projectID: item?.projectID,
//           projectTypeIdInt: item?.projectTypeIdInt,
//         });
//       });
//       handleProjectGUID(projectGuid);
//     }
//   };
//   // const getProjectsList = async () => {
//   //   setIsLoad(true);
//   //   const projects = await axios.get(GetProjectList);
//   //   if (projects) {
//   //     setIsLoad(false);
//   //   }
//   //   setProjectList(projects?.data.data);
//   //   if (projects?.status == 204) {
//   //     setDatanotfound(true);
//   //   }
//   // };

//   // const refreshRequest = () => {
//   //   setRefresh(!refresh);
//   // };
//   const getProjectsList = async () => {
//     setIsLoad(true);
//     const projects = await getAsync('APIClient/ProjectAllSHJC');
//     if (projects) {
//       setIsLoad(false);
//     }
//     setProjectList(projects?.data);
//     if (projects?.status === 204) {
//       setDatanotfound(true);
//     }
//   };

//   const refreshRequest = () => {
//     setRefresh(!refresh);
//   };

//   const handleProjectGUID = async (guids) => {
//     try {
//       setTableData(false);
//       setDatanotfound(false);
//       const response = await postAsync(`APIClient/ListGUID/`, guids);
//       if (response) {
//         setProjectListData(response.data);
//         setDateGet(false);
//         setLoading(false);
//       }
//       if (response?.data?.length == 0) {
//         setTableData(true);
//       }
//     } catch (error) {
//       toast.error(t('Something went wrong, Please try again!'));
//     }
//   };

//   // const fetchData = useCallback(
//   //   async (pid, projectTypeIdInt) => {
//   //     try {
//   //       setLoading(true);
//   //       const sdata = {
//   //         giftTypeID: Number(id),
//   //         userID: Number(userId),
//   //         projectID: pid,
//   //         projectTypeIdInt,
//   //       };

//   //       const response = await axios.post(`${baseURL}/GiftService/CreateGiftProject`, sdata, {
//   //         headers: headersList,
//   //       });
//   //       if (response?.data?.statusCode === 200) {
//   //         toast.success(t('Gift Project created Successfully.'));
//   //         refreshRequest();

//   //         setTableData(false);
//   //       } else if (response?.data?.statusCode === 422) {
//   //         toast.error(t('Project Already exist!'));
//   //       } else {
//   //         toast.error(t('Something went wrong, Please try again!'));
//   //       }

//   //       const responses = await axios.get(GetGiftService, { headers: headersList });
//   //       const projects = await axios.get(GetProjectList);
//   //       setData(responses?.data.data);
//   //       setProjectList(projects?.data.data);
//   //     } catch (error) {
//   //       toast.error(t('Something went wrong, Please try again!'));
//   //     }
//   //   },
//   //   [data],
//   // );
//   // const deleteProject = async (giftProjectID) => {
//   //   const headersList = {
//   //     Authorization: `Bearer ${token}`,
//   //     referralLink: giftProjectID,
//   //   };

//   //   try {
//   //     setLoading(true);
//   //     const response = await axios.post(`${baseURL}/GiftService/DeleteGiftProject`, {}, { headers: headersList });
//   //     if (response.data.statusCode === 200) {
//   //       refreshRequest();
//   //       toast.success(t('Deleted Successfully'));
//   //     } else {
//   //       toast.error(t('Something went wrong, Please try again!'));
//   //     }
//   //   } catch (error) {
//   //     toast.error(t('Something went wrong, Please try again!'));
//   //   }
//   // };

//   const fetchData = useCallback(
//     async (pid, projectTypeIdInt) => {
//       try {
//         setLoading(true);
//         setLoadingBtnId(pid); // jis button pe click hua uska id save karlo
//         const sdata = {
//           giftTypeID: Number(id),
//           userID: Number(userId),
//           projectID: pid,
//           projectTypeIdInt,
//         };

//         const response = await postAsync(`/GiftService/CreateGiftProject`, sdata, {
//           headers: headersList,
//         });

//         if (response?.statusCode === 200) {
//           toast.success(t('Gift Project created Successfully.'));
//           refreshRequest();
//           setTableData(false);
//         } else if (response?.statusCode === 422) {
//           toast.error(t('Project Already exist!'));
//           return;
//         } else {
//           toast.error(t('Something went wrong, Please try again!'));
//         }

//         const responses = await getAsync('GiftService/GetGiftProjectByGiftTypeId', headersList);
//         const projects = await getAsync('APIClient/ProjectAllSHJC');
//         setData(responses?.data);
//         setProjectList(projects?.data);
//       } catch (error) {
//         toast.error(t('Something went wrong, Please try again!'));
//       }
//     },
//     [data],
//   );

//   const deleteProject = async (giftProjectID) => {
//     const headersList = {
//       Authorization: `Bearer ${token}`,
//       referralLink: giftProjectID,
//     };

//     try {
//       setLoading(true);
//       const response = await postAsync(`/GiftService/DeleteGiftProject`, {}, headersList);
//       if (response.statusCode === 200) {
//         refreshRequest();
//         toast.success(t('Deleted Successfully'));
//       } else {
//         toast.error(t('Something went wrong, Please try again!'));
//       }
//     } catch (error) {
//       toast.error(t('Something went wrong, Please try again!'));
//     }
//   };

//   return (
//     <>
//       <div className="pb-5">
//         <h1 className="text-xl font-bold sm:text-2xl text-customgreen text-center pt-10 ">
//           {type} {t('Projects')}
//         </h1>
//         {isLoad ? (
//           <LoadingAnimation
//             imageStyling={''}
//             styling={'flex items-center py-5 align-middle justify-center space-x-2'}
//           />
//         ) : (
//           projectList.length > 0 && (
//             <div className="flex flex-wrap justify-center gap-3 pb-10">
//               {projectList.map((data, index) => {
//                 return (
//                   <div data-aos="zoom-in" data-aos-once="true" className="justify-center items-center" key={index}>
//                     <Giftselectioncards
//                       index={index}
//                       data={data}
//                       title={data.templateName.substring(0, 20)}
//                       img={data.file_Stream}
//                       totalCost={data.totalCost}
//                       id={data.projectID}
//                       projectGuID={data?.id}
//                       onClick={fetchData}
//                     />
//                   </div>
//                 );
//               })}
//             </div>
//           )
//         )}
//         {datanotfound && <DataNotFound />}
//         <div className="flex flex-col px-5 ">
//           <h1 className="font-bold sm:text-2xl text-center  text-xl text-customgreen">{t('Service for Gift')}</h1>
//           <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
//             <div className="text-sm tableData text-center  rtl:text-right">
//               <div className="shadow   overflow-y-auto border-b border-gray-200 sm:rounded-lg">
//                 <table className="w-full divide-y mt-3 divide-gray-200">
//                   <thead className=" font-bold  text-white whitespace-nowrap bg-customgreen uppercase">
//                     <tr>
//                       {headers.map((header, index) => (
//                         <th
//                           key={index}
//                           scope="col-2"
//                           className=" py-3 text-center text-xs font-medium bg-customgreen text-white uppercase tracking-wider"
//                         >
//                           {t(header)}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {!loading &&
//                       projectListData.map((row, rowIndex) => (
//                         <tr key={rowIndex}>
//                           <td className="px-6 py-4 text-center whitespace-nowrap text-sm text-gray-500">
//                             {rowIndex + 1}
//                           </td>
//                           <td className="px-6 py-4 text-center whitespace-nowrap text-sm text-gray-500">
//                             {row.templateName}
//                           </td>

//                           <td className="px-6 py-4 text-center whitespace-nowrap text-sm text-gray-500">
//                             <button
//                               className="bg-customgreen text-center hover:bg-hovergreen text-white font-bold py-2 px-4 rounded-full"
//                               onClick={() => deleteProject(row['id'])}
//                             >
//                               {t('Delete')}
//                             </button>
//                           </td>
//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//                 {loading && <LoadingAnimation />}
//                 {tableData && <DataNotFound />}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddGiftService;


import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { PageHitCountApi } from '../../../shared/Helper';
import { toast } from 'react-toastify';
import { getStorage } from '../../../libs/getStorage';
import baseURL, { getAsync, postAsync } from '../../../components/helper/axiosHelper';
import { DataNotFound } from '../../../components/DataNotFound';
import { t } from 'i18next';
import LoadingAnimation from '../../../components/LoadingAnimation';
import Giftselectioncards from '../../../components/cards/Giftselectioncards';

const AddGiftService = () => {
  const [data, setData] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [projectListData, setProjectListData] = useState([]);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [dateGet, setDateGet] = useState(false);
  const [tableData, setTableData] = useState(false);
  const [loading, setLoading] = useState(false);
  const userId = getStorage('id');
  const [loadingBtnId, setLoadingBtnId] = useState(null); 
  const [selectedProjects, setSelectedProjects] = useState(new Set()); 

  const headers = ['sNo', 'Project Name', 'Delete Projects'];

  const hasMounted = useRef(false);

  const { id, type } = useParams();
  const token = localStorage.getItem('token');
  const { pathname } = useLocation();

  let headersList = {
    Accept: '*/*',
    Authorization: `Bearer ${token}`,
    id: id,
  };
  useEffect(() => {
    if (!hasMounted.current) {
      getProjectsList();
      hasMounted.current = true;
    }
    onRender();
  }, [refresh]);

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const onRender = async () => {
    const response = await getAsync('GiftService/GetGiftProjectByGiftTypeId', headersList);
    setData(response.data);
    if (response.data) {
      const projectGuid = [];
      response?.data.forEach((item) => {
        projectGuid.push({
          projectID: item?.projectID,
          projectTypeIdInt: item?.projectTypeIdInt,
        });
      });
      handleProjectGUID(projectGuid);
    }
  };

  const getProjectsList = async () => {
    setIsLoad(true);
    const projects = await getAsync('APIClient/ProjectAllSHJC');
    if (projects) {
      setIsLoad(false);
    }
    setProjectList(projects?.data);
    if (projects?.status === 204) {
      setDatanotfound(true);
    }
  };

  const refreshRequest = () => {
    setRefresh(!refresh);
  };

  const handleProjectGUID = async (guids) => {
    try {
      setTableData(false);
      setDatanotfound(false);
      const response = await postAsync(`APIClient/ListGUID/`, guids);
      if (response) {
        setProjectListData(response.data);
        setDateGet(false);
        setLoading(false);
        const selectedIds = new Set(response.data.map((item) => item.id));
        setSelectedProjects(selectedIds);
      }
      if (response?.data?.length == 0) {
        setTableData(true);
      }
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const fetchData = useCallback(
    async (pid, projectTypeIdInt) => {
      try {
        setLoading(true);
        setLoadingBtnId(pid); 
        const sdata = {
          giftTypeID: Number(id),
          userID: Number(userId),
          projectID: pid,
          projectTypeIdInt,
        };

        const response = await postAsync(`/GiftService/CreateGiftProject`, sdata, {
          headers: headersList,
        });

        if (response?.statusCode === 200) {
          refreshRequest();
          setTableData(false);

          setSelectedProjects((prev) => new Set([...prev, pid]));
        } else if (response?.statusCode === 422) {
          toast.error(t('Project Already exist!'));
          return;
        } else {
          toast.error(t('Something went wrong, Please try again!'));
        }

        const responses = await getAsync('GiftService/GetGiftProjectByGiftTypeId', headersList);
        const projects = await getAsync('APIClient/ProjectAllSHJC');
        if (response?.statusCode === 200) {
          toast.success(t('Gift Project created Successfully.'));
          setData(responses?.data);
          setProjectList(projects?.data);
        }
      } catch (error) {
        toast.error(t('Something went wrong, Please try again!'));
      } finally {
        setLoading(false);
        setLoadingBtnId(null); 
      }
    },
    [data],
  );

  const deleteProject = async (giftProjectID) => {
    const headersList = {
      Authorization: `Bearer ${token}`,
      referralLink: giftProjectID,
    };

    try {
      setLoading(true);
      const response = await postAsync(`/GiftService/DeleteGiftProject`, {}, headersList);
      if (response.statusCode === 200) {
        refreshRequest();
        toast.success(t('Deleted Successfully'));

        setSelectedProjects((prev) => {
          const newSet = new Set(prev);
          newSet.delete(giftProjectID);
          return newSet;
        });
      } else {
        toast.error(t('Something went wrong, Please try again!'));
      }
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="pb-5">
        <h1 className="text-xl font-bold sm:text-2xl text-customgreen text-center pt-10 ">
          {type} {t('Projects')}
        </h1>
        {isLoad ? (
          <LoadingAnimation
            imageStyling={''}
            styling={'flex items-center py-5 align-middle justify-center space-x-2'}
          />
        ) : (
          projectList.length > 0 && (
            <div className="flex flex-wrap justify-center gap-3 pb-10">
              {projectList.map((data, index) => {
                return (
                  <div data-aos="zoom-in" data-aos-once="true" className="justify-center items-center" key={index}>
                    <Giftselectioncards
                      index={index}
                      data={data}
                      title={data.templateName.substring(0, 20)}
                      img={data.file_Stream}
                      totalCost={data.totalCost}
                      id={data.projectID}
                      projectGuID={data?.id}
                      onClick={fetchData}
                      isLoading={loadingBtnId === data.id} 
                      isSelected={selectedProjects.has(data.id)} 
                    />
                  </div>
                );
              })}
            </div>
          )
        )}
        {datanotfound && <DataNotFound />}
        <div className="flex flex-col px-5 ">
          <h1 className="font-bold sm:text-2xl text-center  text-xl text-customgreen">{t('Service for Gift')}</h1>
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <div className="text-sm tableData text-center  rtl:text-right">
              <div className="shadow   overflow-y-auto border-b border-gray-200 sm:rounded-lg">
                <table className="w-full divide-y mt-3 divide-gray-200">
                  <thead className=" font-bold  text-white whitespace-nowrap bg-customgreen uppercase">
                    <tr>
                      {headers.map((header, index) => (
                        <th
                          key={index}
                          scope="col-2"
                          className=" py-3 text-center text-xs font-medium bg-customgreen text-white uppercase tracking-wider"
                        >
                          {t(header)}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {!loading &&
                      projectListData.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          <td className="px-6 py-4 text-center whitespace-nowrap text-sm text-gray-500">
                            {rowIndex + 1}
                          </td>
                          <td className="px-6 py-4 text-center whitespace-nowrap text-sm text-gray-500">
                            {row.templateName}
                          </td>

                          <td className="px-6 py-4 text-center whitespace-nowrap text-sm text-gray-500">
                            <button
                              className="bg-customgreen text-center hover:bg-hovergreen text-white font-bold py-2 px-4 rounded-full"
                              onClick={() => deleteProject(row['id'])}
                            >
                              {t('Delete')}
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {loading && <LoadingAnimation />}
                {tableData && <DataNotFound />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddGiftService;
